// removed by extract-text-webpack-plugin
module.exports = {"root":"CodeEditor_root_1Fz","menu":"CodeEditor_menu_24y","close":"CodeEditor_close_otZ","editor":"CodeEditor_editor_OLC","actionButton":"CodeEditor_actionButton_3LD"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CodeEditor/CodeEditor.css
 ** module id = 565
 ** module chunks = 0
 **/